import vi from '$/locales/vi'
import ja from '$/locales/ja'
import en from '$/locales/en'

export default {
  vi,
  ja,
  en,
}
